import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ShopifyReviewDialogState } from './shopify-review-dialog.reducer';

export const getShopifyReviewDialogState = (state: RootState) => state.shopifyReviewDialog;

export const getShopifyReviewDialogIsDisplayed = createSelector(
    getShopifyReviewDialogState,
    (state: ShopifyReviewDialogState) => state.isDisplayed
);
